import { render, staticRenderFns } from "./BTCDialog.vue?vue&type=template&id=6f4cb9b6&scoped=true&"
import script from "./BTCDialog.vue?vue&type=script&lang=js&"
export * from "./BTCDialog.vue?vue&type=script&lang=js&"
import style0 from "./BTCDialog.vue?vue&type=style&index=0&id=6f4cb9b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4cb9b6",
  null
  
)

export default component.exports